<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="reports-drawer"
      title="Reports Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconBarChart,
  BIconFileText,
  BIconClipboard
} from "bootstrap-vue";

import ReportsMySales from "@/components/Reports/ReportsMySales";
import ReportsRefunds from "@/components/Reports/ReportsRefunds";
import ReportsReportsV1 from "@/components/Reports/ReportsReportsV1";
import ReportsStoresSale from "@/components/Reports/ReportsStoresSale";
import ReportsStoresSaleV2 from "@/components/Reports/ReportsStoresSaleV2"; 
import ReportsUsersSale from "@/components/Reports/ReportsUsersSale";
import FinanceSalesReports from "@/components/Reports/FinanceSalesReports";
import DailyBatchReport from "@/components/Reports/DailyBatchReport";
import SalesReport from "@/components/Reports/SalesReport";
import SalesReportDashboard from "@/components/Reports/SalesReportDashboard";
import ReportsSalesStatsPage from "@/components/Reports/ReportsSalesStatsPage";
import ReportsMyPayroll from "@/components/Reports/ReportsMyPayroll";


export default {
  name: "ReportsMain",

  components: {
    ReportsMySales,
    ReportsRefunds,
    ReportsReportsV1,
    ReportsStoresSale,
    ReportsStoresSaleV2,   // ✅ NEW
    ReportsUsersSale,
    FinanceSalesReports,
    DailyBatchReport,
    SalesReport,
    SalesReportDashboard,
    ReportsSalesStatsPage,
      ReportsMyPayroll,
    BIconList,
    BIconBarChart,
    BIconFileText,
    BIconClipboard
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
        {
          title: "MY SALES",
          icon: "bar-chart",
          roles: ["admin", "locationadmin", "salesperson"],
          component: "ReportsMySales"
        },
        // {
        //   title: "NEW SALE REPORT",
        //   icon: "bar-chart",
        //   roles: ["admin", "locationadmin", "salesperson"],
        //   component: "SalesReport"
        // },
        {
          title: "SALES REPORT DASHBOARD",
          icon: "bar-chart",
          roles: ["admin", "locationadmin", "salesperson"],
          component: "SalesReportDashboard"
        },
        {
          title: "SALES STATS",
          icon: "bar-chart",
          roles: ["admin", "locationadmin", "salesperson"],
          component: "ReportsSalesStatsPage"
        },
        {
          title: "SALES VS REFUNDS",
          icon: "clipboard",
          roles: ["admin", "accountmanager", "locationadmin", "accountuser"],
          component: "ReportsRefunds"
        },
        {
          title: "USER + STORE SALES",
          icon: "file-text",
          roles: ["admin", "accountmanager", "locationadmin", "accountuser"],
          component: "ReportsReportsV1"
        },
        {
          title: "STORE SALES",
          icon: "file-text",
          roles: ["admin"],
          component: "ReportsStoresSale"
        },
        {
          title: "STORE SALES V2",              // ✅ NEW TAB
          icon: "file-text",
          roles: ["admin"],
          component: "ReportsStoresSaleV2"
        },
        {
          title: "USER SALES",
          icon: "file-text",
          roles: ["admin"],
          component: "ReportsUsersSale"
        },
        {
          title: "FINANCE SALES",
          icon: "bar-chart",
          roles: ["admin", "accountmanager", "locationadmin", "accountuser"],
          component: "FinanceSalesReports"
        },
        {
          title: "DAILY BATCH",
          icon: "file-text",
          roles: ["admin", "accountmanager", "locationadmin", "accountuser"],
          component: "DailyBatchReport"
        },
         {
          title: "MY PAYROLL",                    // ✅ NEW
          icon: "wallet2",
          roles: ["admin", "locationadmin", "salesperson"],
          component: "ReportsMyPayroll"
        },
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("User data parsing failed:", err);
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/ReportsMain.vue